// extracted by mini-css-extract-plugin
export default {"wrapper":"eT-z"};